import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { updateBrokerGross } from 'bundles/apex/pipeline/settings/store/actions';

import ManagedFormGroup from 'components/form/managed_input/form_group';
import { brokerGrossOptions } from '../config';

export function BrokerGrossSettings({ viewConfig, updateBrokerGross }) {
  return (
    <ManagedFormGroup
      inline={false}
      label="Broker / Brokerage Gross"
      name="brokerGross"
      options={brokerGrossOptions}
      type="radioGroup"
      value={viewConfig.brokerGross}
      onValueChange={value => updateBrokerGross(value)}
    />
  );
}

BrokerGrossSettings.propTypes = {
  updateBrokerGross: PropTypes.func.isRequired,
  viewConfig: PropTypes.shape({
    brokerGross: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  viewConfig: state.view,
});

const mapDispatchToProps = {
  updateBrokerGross,
};

export default connect(mapStateToProps, mapDispatchToProps)(BrokerGrossSettings);
